import { getNewsLargeImageUrl } from "../../../utils/imageUrl";
import { formatNewsDate } from "../../../utils/news";
import { useTranslation } from "../../../i18n/LanguageProvider";

function NewsArticle({ news, paragraphs }) {
    const { language, t } = useTranslation();

    return (
        <article className="news-detail__article card-common">
            {news.published_at && (
                <time className="news-detail__date">{formatNewsDate(news.published_at, language)}</time>
            )}
            <h1 className="news-detail__title">{news.title}</h1>
            <img src={getNewsLargeImageUrl(news.image_url)} alt={news.title} className="news-detail__image" />
            <div className="news-detail__content">
                {paragraphs.map((paragraph, index) => (
                    <p key={index}>{paragraph}</p>
                ))}
            </div>
            {news.source_url && (
                <a href={news.source_url} className="news-detail__source" target="_blank" rel="noreferrer">
                    {t("news.source")}
                </a>
            )}
        </article>
    );
}

export default NewsArticle;
